import React, { FC, useMemo } from "react";
import { Icon, View, COLOR } from "@lookiero/aurora";
import { useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Feature } from "../../../../../../domain/entities/product/Features";
import { Tooltip, Placement } from "../../../../components/tooltip/Tooltip";
import { DOMAIN } from "../../../../i18n/i18n";
import { ICON_BY_FEATURE_ID } from "./GarmentCareIcons.definition";
import { style as garmentCareIconsStyle } from "./GarmentCareIcons.style";

interface GarmentCareIconsProps {
  readonly features: Feature[];
}

const GarmentCareIcons: FC<GarmentCareIconsProps> = ({ features }) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });

  const style = useMemo(() => garmentCareIconsStyle(), []);

  return (
    <>
      {features.map((item) => {
        return (
          <View key={item.id} style={style.container}>
            {item.featureValues.map(({ id, key }) => {
              const iconName = ICON_BY_FEATURE_ID[id];

              return iconName ? (
                <View key={iconName} style={style.icon}>
                  <Tooltip
                    placement={Placement.BOTTOM}
                    content={
                      <Text level={2} variant="detail">
                        {formatMessage({ id: key })}
                      </Text>
                    }
                  >
                    {(visible) => <Icon name={iconName} style={{ color: visible ? COLOR.ICON : COLOR.ICON_LIGHT }} />}
                  </Tooltip>
                </View>
              ) : null;
            })}
          </View>
        );
      })}
    </>
  );
};

export { GarmentCareIcons };
